if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        this.mobileSlides = this.querySelector('.swiper').dataset.slidesMobile || 1.3;
        this.desktopSlides = this.querySelector('.swiper').dataset.slidesDesktop || 2.3;

        this.sliderOptions = {
          slidesPerView: this.mobileSlides,
          spaceBetween: 10,
          loop: false,
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          breakpoints: {
            768: {
              slidesPerView: this.desktopSlides
            }
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };
      }

      connectedCallback() {
        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
